const routes = {
  createNewPassword: '/create-new-password',
  home: '/',
  dashboardTest: '/dashboard-test',
  forgotPassword: '/forgot-password',
  login: '/login',
  roadmaps: '/roadmaps',
  support: '/support',
  publicLinks: '/public-links',
  ui: '/ui',
  canvas: '/canvas',
  account: '/account',
  roadmap: '/roadmap',
  view: '/view',
  timelineEditor: '/timeline-editor',
  saml2: '/saml2/login',
  access: '/access',
  saml2Setup: '/saml2',
  unauthorized: '/unauthorized',
};

const maintenanceRoutes = {
  maintenance: '/maintenance',
};
export default routes;
export { maintenanceRoutes };
